/* eslint-disable unicorn/filename-case */
/* eslint-disable camelcase */

import { ILanguageData } from "../props";

export const zhTW: ILanguageData = {
  welcome_login: "歡迎登錄",
  account: "賬號",
  password: "密碼",
  remember_pwd: "記住密碼",
  login: "登錄",
  login_account_required: "必須輸入賬號",
  login_pwd_required: "必須輸入密碼",
  input_keyword_search: "請輸入關鍵字搜索",
  learning_data: "學習數據",
  my_course: "我的課程",
  my_exam: "我的考試",
  more_courses: "更多課程",
  exam_review: "考試評審",
  departmental_course: "部門教程",
  update_tutorial: "更新教程",
  all: "全部",
  pending_participation_exam: "待參加",
  pending_review_exam: "待評審",
  not_passed_exam: "未通過",
  passed_exam: "已通過",
  course_number: "課程編號",
  course_title: "課程名稱",
  exam_time: "考試時間",
  exam_duration: "考試時長",
  quiz_creator: "出題人",
  total_question_number: "總題數",
  exam_number: "考試編號",
  remaining_exam_attempts: "剩餘考試次數",
  times: "次",
  check_score: "查看成績",
  start_exam: "開始考試",
  compulsory_course: "必修",
  elective_course: "選修",
  duration: "時長",
  course: "課程",
  featured: "教程",
  pcs: "個",
  minutes: "分鐘",
  data_learned: "已學習", // 不確定
  to_learn: "待學習",
  learned: "已學習",
  learning: "學習中",
  history: "歷史記錄",
  learning_dueation: "學習時間",
  lecturer: "講師",
  exam_start_time: "考試開始時間",
  exam_end_time: "考試結束時間",
  // score: "得分：{{score}}分",
  score_one: "得分：{{score}}分",
  score_other: "得分：{{score}}分",
  view_details: "查看詳情",
  copy_link: "複製鏈接",
  failed_grade: "不及格",
  passed_grade: "及格",
  single_choice: "單選",
  multiple_choice: "多選",
  judgment: "判斷",
  fill_blank: "填空",
  // total_score: "總分：{{totalScore}}分",
  total_score_one: "總分：{{totalScore}}分",
  total_score_other: "總分：{{totalScore}}分",
  // questions_total: "共{{questionCount}}題",
  questions_total_other: "共{{questionCount}}題",
  questions_total_one: "共{{questionCount}}題",
  exam_submission_time: "考卷提交時間",
  exam_paper_number: "考卷編號",
  number_of_associated_course: "關聯課程編號",
  exam_marker: "評卷人",
  number_of_questions_to_be_reviewed: "待評審題數",
  review_status: "評審狀態",
  operation: "操作",
  to_be_reviewed: "待評審",
  reviewed: "已評審", // 未確定
  distributed: "已派發", // 未确定
  review: "評審",
  department: "部門",
  position: "職位",
  nameOfViewer: "觀看人姓名",
  organizationOfTheViewer: "觀看人所屬組織",
  viewingStatus: "觀看狀態",
  viewingTime: "觀看時間",
  question_and_answer: "問答",
  i_posted: "我發佈的",
  name: "名稱",
  description: "描述",
  personnel_scope: "人員範圍",
  shelf_time: "上架時間",
  courseware_upload: "課件",
  courseware_stage_has_exam: "課件所在階段有考試",
  click_or_drag: "點擊或將文件拖拽到這裏上傳",
  extension_support: "支持擴展名",
  cancel: "取消",
  confirm: "確認",
  organizational_structure: "組織架構",
  selected_person: "已選人員",
  message_center: "消息中心",
  message_list: "消息列表",
  unread_message: "未讀消息",
  read_message: "已讀消息",
  on_the_shelf: "上架中",
  removed_from_shelves: "已下架",
  no_related_content: "抱歉，沒有找到相關內容",
  unwatched: "未觀看",
  watching: "觀看中",
  watched: "已觀看",
  viewing_record: "觀看記錄",
  my_viewing_record: "我的觀看記錄",
  delete: "刪除",
  modify: "修改",
  publisher: "發佈者",
  viewing_time: "觀看時間",
  name_of_viewer: "觀看人姓名",
  organization_of_the_viewer: "觀看人所屬組織",
  viewing_status: "觀看狀態",
  tutorial_staff_watches_the_record: "教程人員觀看記錄",
  course_introduction: "課程簡介",
  more: "更多",
  course_evaluation: "課程評價",
  correctAnswerMessage: "恭喜你，回答正確！",
  wrongAnswer: "很遺憾，回答錯誤！",
  yourAnswer: "您的答案：{{yourAnswer}}",
  correctAnswer: "標準答案：{{correctAnswer}}",
  answerAnalysis: "答案解析：{{answerAnalysis}}",
  comment: "評語：{{comment}}",
  mark: "評分：{{score}}分",
  remainingTime: "剩餘時間：",
  submit: "提交",
  submit_failed: "提交失敗，請重試！",
  submit_success: "提交成功！",
  viewing_history: "觀看歷史記錄",
  courseware_name: "課件名稱",
  courseware_number: "課件編號",
  dept_course: "部門教程",
  dept_tutorials_number: "部門教程編號",
  my_dept_tutorials: "我學習的部門教程",
  course_description: "課程描述",
  tutorial_publish: "教程發布",
  tutorial_description: "教程簡介",
  copy: "複製",
  copy_success: "複製成功",
  copy_failed: "複製失敗",
  i_learned: "我學習的",
  multiplier: "倍速",
  clarity: "清晰度",
  whether_to_delete_data: "是否刪除數據",
  whether_to_give_up_save: "是否確認放棄保存",
  yes: "是",
  no: "否",
  file_type_not_supported: "僅支持MP4、MOV、JPG、PNG、PDF格式",
  student_count: "學員總數",
  course_instructor: "課程講師",
  learning_progress: "學習進度",
  my_pending_courses: "我的待學習課程",
  dept_course_number: "部門課程編號",
  join_course: "是否參與課程",
  course_expired: "課程已超出可學習時間，無法進行學習",
  no_tutorials: "暫無教程",
  upload_type_tips: "只能上傳同一類附件，且MP3、MP4和PDF只能上傳一份",
  examination_title: "考試名稱", // 不確定
  paper_number: "考卷編號", // 不確定
  submitter: "提交人", // 不確定
  submission_time: "提交時間", // 不確定
  distribution_success: "成績派發成功", // 不確定
  distribute: "派發成績", // 不確定
  attachment: "附件",
  confirm_exit_exam: "是否退出考試？",
  clear_unread: "一鍵已讀",
  scan_qr_code: "請掃描以上二維碼填寫課程評價",
  distribution_select_results: "請選擇要派發的成績",
  pending_examination: "待審批考試", // 不确定
  test_paper_submission_time: "考卷提交時間", // 不確定
  answer: "答案", // 不確定
  review_score: "評分", // 不確定
  points: "分", // 不確定
  review_remark: "評語", // 不確定
  review_remark_empty: "評語不能為空", // 不确定
  review_points_empty: "評分不能為空", // 不确定
  tutorials: "教程",
  tutorials_number: "教程編號",
  logout: "退出",
  version: "版本號",
  empty_exams: "暫無考試",
  empty_course: "暫無課程",
  empty_score: "暫無成績",
  empty_content: "暫無内容",
  clear: "清空",
  echo_avatar: "Echo Avatar",
  translation_video: "翻譯視頻",
  start_make: "開始製作",
  sure_make: "確認製作",
  cancel_making: "關閉",
  cancel_make: "取消製作",
  language: "語種",
  tone: "音色",
  make_state: "製作狀態",
  speech_draft: "講稿",
  download: "下載",
  download_failed_open_tab: "下載失敗，請在新標籤自行下載",
  try_listen: "試聽",
  template_download: "模版下载",
  output_language_speech_color_selection: "輸出語種音色選擇",
  original_language: "原始語言",
  translation_language: "轉譯語種",
  video_duration: "視頻時長",
  video_name: "視頻名稱",
  ea_note: "注 : 如需克隆音色，請到Echo Avatar客戶端製作（請使用同一帳號登錄）",
  ea_tooltip:
    "講稿可自行選擇是否導入；如不導入，系統將對視頻中的音頻進行人工智能識別，智能生成講稿；如導入，系統將按照講稿內容進行多語種版本製作。",
  total_video_duration: "視頻總時長",
  original: "原文",
  translation: "譯文",
  word_count: "字數",
  back: "返回",
  sure: "確定",
  preview: "預覽",
  batch_download: "批量下載",
  multilingual_translation: "多語言轉譯",
  ea_hash: "Hash",
  making: "製作中",
  please_select_the_original_language: "請選擇原始語言",
  please_select_the_target_language: "請選擇目標語言",
  please_select_language: "請選擇語種",
  please_select_a_tone: "請選擇音色",
  whether_to_cancel_production: "是否取消製作",
  search_history: "搜索歷史",
  target_language: "目標語言",
  create_translation_video: "創建翻譯視頻項目",
  advanced_option: "高級選項",
  subtitles: "字幕",
  video_advanced_option: {
    option1: "保留背景音（保留配樂、噪音等非人聲）",
    option2: "直接翻譯（跳過校驗文本環節，直接輸出經過視頻）",
    option3: "字幕（生成目標語言字幕）",
  },
  original_language_and_target_language_conflict:
    "原始語言不能與目標語言相同，請重新選擇",
  save: "保存",
  translate: "翻譯",
  ai_analysis: "AI分析",
  regular_duration: "常規用時",
  recommended_duration: "推薦用時",
  ai_rewrite: "AI重寫",
  slow_speech_rate_tip: {
    option1: "語速緩慢",
    option2: "翻譯後的文本比原始文本短。我們建議增加自然語言節奏的字符數。",
  },
  fast_speech_rate_tip: {
    option1: "語速過快",
    option2: "翻譯後的文本比原始文本長。我們建議減少自然語言節奏的字符數。",
  },
  subtitle_time_range_is_incorrect: {
    option1: "開始時間不能超過結束時間",
    option2: "結束時間不能超過下一句的開始時間",
  },
  video_time_format: "時間格式為HH:mm:ss,mmm",
  making_tips: "正在生成 {{progress}}%",
  no_data: "暫無數據",
  index_page: "首頁",
  share: "分享",
  playing_failed: "播放失敗",
  intelligent_creation: {
    intelligent_creation: "智能創作",
    dual_podcast: "雙人播客",
    single_person_talk: "單人口播",
    background_image: "背景畫面",
    creation_type: "創作類型",
    audio: "音頻",
    video: "視頻",
    upload_text: "點擊上傳",
    upload_tip: "僅支持上傳.pdf，且大小不超過10mb",
    podcard_content_tip: "請輸入播客內容或上傳PDF文件",
    ai_creation: "AI 創作",
    use_my_script: "用我的腳本",
    podcast_content_input_placeholder_ai:
      "輸入主題、想法或上傳參考資料，讓 AI 一鍵生成完整播客腳本。",
    podcast_content_input_placeholder_custom:
      "輸入已有的腳本，系統自動轉成對應播客腳本。",
    script_format_requirement:
      '格式提示：\n·需換行區分"主持人"和"採訪嘉賓"的對白。\n·對話角色僅限"主持人"和"採訪嘉賓"。',
    script_format_example:
      "【格式示例】\n主持人：哈嘍各位……\n採訪嘉賓：對的，我們……\n主持人：那……\n採訪嘉賓：是的，其實……",
    script_format_error: "腳本不符合格式要求，請編輯後重試。",
    input_script_placeholder: "請輸入腳本",
    apply_script: "應用腳本",
    mandarin: "普通話",
    cantonese: "粵語",
    compere: "主持人",
    interview_guest: "採訪嘉賓",
    my_tone: "我的音色",
    digital_image_and_timbre: "數字形象和音色",
    my_customization: "我的定製",
    system_tone: "系統音色",
    podcast_content: "播客內容",
    system_presets: "系統預設",
    custom: "自定義",
    customize: "定製",
    tone_genere_tip: "音色生成中，預計等待{{minutes}}分鐘",
    generate_script: "生成腳本",
    no_content: "請先完成設置~",
    generate_audio: "生成音頻",
    generate_video: "生成視頻",
    audio_balance: "音頻餘額(時:分:秒)",
    video_balance: "視頻餘額(時:分:秒)",
    audio_generate_tip:
      "注：因AI生成特性，最終音視頻時長可能存在一定偏差，額度扣減將按實際時長執行。",
    too_long_script_tip:
      "腳本整體篇幅過長，不符合時長設置，請重新編輯或通過指令讓AI協助修改。",
    too_short_script_tip:
      "脚本整体篇幅过短，不符合时长设置，请重新编辑或通过指令让AI协助修改。",
    tone_customization: "音色定製",
    upload_file_tip1: "文件過大，請重新上傳",
    upload_file_tip2: "時長不符合要求，請重新上傳",
    whether_to_confirm_deletion: "是否確認刪除?",
    whether_to_confirm_submission: "是否確認提交?",
    material_text: "素材文本",
    material_text_tip:
      "文本由AI識別生成，如和原素材不一致，可自行修改，以提升音色克隆準確度。",
    material_language: "素材語種",
    tone_name: "音色名稱",
    reference_audio: "參考音頻",
    upload_audio_tip:
      "請上傳個人清晰的人聲音頻（語種需和“素材語種”一致，要求無背景雜音、僅1個人的聲音）",
    upload_audio_tip2: "格式：MP3 大小：150MB以內",
    generating: "生成中",
    script_generating: "腳本生成中",
    script_generat_failed: "腳本生成失敗,請重新嘗試",
    basic_setting_changed_tip: "設置已修改，請重新生成腳本！",
    delete_tone_tip1: "音色已被選擇，無法刪除，請調整後重試",
    delete_tone_tip2: "音頻正在生成中，無法刪除",
    generate_failed_tip: "生成失敗，請重新嘗試",
    queuing_tip: "排隊中，預計等待幾分鐘",
    queuing_tip1: "排隊中，預計{{minutes}}分鐘後開始生成",
    submit_tip: "（提交後無法再次修改）",
    draft_tip: "提示",
    draft_tip1: "存在排隊中/生成中/已完成的生成任務，是否繼續？",
    draft_tip2: "（放棄後將不做保存）",
    back_tip1: "是否確認返回？",
    back_tip2:
      "（如有排隊中/生成中/已完成的生成任務，下次進入時可再次查看，如無則不做保存）",
    background_sound_error_tip: "背景雜音明顯，請重新上傳",
    invalid_voice_error_tip: "未檢測到有效人聲，請重新上傳",
    multiple_voices_error_tip: "檢測到多人聲音，請重新上傳",
    audio_check_failed_error_tip: "檢測失敗，請重新上傳",
    no_pdf_file_error_tip: "不是 PDF 文件，請重新上傳",
    checking: "檢測中",
    host: "主持人",
    guest: "採訪嘉賓",
    digital_image: "數字形象",
    digital_image_group: "數字形象組合",
    add_digital_image_group: "新增數字形象組合",
    my_digital_images: "我的數字形象",
    no_digital_image_tip: "暫無選項，請先完成定製！",
    ai_generate: "AI生成",
    over_word_limit_tip: "字數已達上限，超出部分無法錄入。",
    upload_photo: "上傳照片",
    upload_photo_tip1:
      "請上傳個人照片（單人、正面，確保臉部無遮擋），用於生成數字形象",
    upload_photo_tip2: "格式：png/jpg 大小：10MB以內",
    under_inspection: "檢測中",
    digital_image_customization: "數字形象定製",
    least_one_dialogue_box_tip: "最少要有一個對話框",
    detect_faild_tip: "服務繁忙, 請稍後重試",
    no_full_face_image_tip: "請上傳完整正臉照片",
    no_single_person_image_tip: "僅支持單人照片，請重新上傳",
    contains_illegal_content_tip: "含違規內容，請重新上傳",
    clarity_low_tip: "清晰度過低，請重新上傳",
    no_original_image_tip: "請直接上傳原圖",
    simple_chinese: "簡體中文",
    traditional_chinese: "繁體中文",
    over_limit_tip: "{{name}}已超當前可用上限，如需新增，請先刪除超出部分。",
    personal_tone: "個人音色",
    personal_digital_image: "個人數字形象",
    personal_digital_image_tip: "請先新增數字形象組合",
    personal_tone_tip: "音色不能為空",
    no_generation_result: "暫無生成結果",
    digital_human_footage: "數字人畫面",
    add_digital_human_footage: "新增數字人畫面",
    digital_human_footage_tip: "請先新增數字人畫面",
    creation_content: "創作內容",
  },
  input_placeholder: "請輸入",
  no_permissions: "暫無權限",
  add: "新增",
  delete_success: "刪除成功",
  route_error: "路由錯誤！",
};
